export const SUPPORT_PHONE = "+254 703 395 951";
